import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  box-sizing: border-box;
  width: 100%;
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp24};
  padding: ${props => props.theme.whiteLabel.spacing.sp32} ${props => props.theme.whiteLabel.spacing.sp24};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.grey.tone50};
`
